<template>
  <div>
    <div class="flex items-center gap-4 pb-4">
      <router-link
        v-for="button in buttons"
        :key="button.fragment"
        :to="button.fragment"
        class="rounded border px-4 py-2 font-semibold transition-colors duration-300"
        :class="
          activeFragment === button.fragment
            ? 'border-orange-300 bg-orange-300 text-orange-900'
            : 'border-gray-400 bg-gray-100 text-gray-900 hover:bg-gray-200'
        "
      >
        {{ button.title }}
      </router-link>
    </div>

    <div v-if="activeFragment === '#client-properties'">
      <ClientProperties :client="client" />
    </div>

    <div v-if="activeFragment === '#device-uploads'">
      <DeviceUploads :client="client" />
    </div>

    <div v-if="activeFragment === '#device-twin'">
      <DeviceTwin :client="client" />
    </div>
  </div>
</template>

<script>
import ClientProperties from "@/components/Tools/IvyClients/DetailsPanel/ClientProperties.vue";
import DeviceUploads from "@/components/Tools/IvyClients/DetailsPanel/DeviceUploads.vue";
import DeviceTwin from "@/components/Tools/IvyClients/DetailsPanel/DeviceTwin.vue";

export default {
  name: "IvyClientDetailPanel",
  components: { DeviceUploads, ClientProperties, DeviceTwin },
  props: {
    client: Object,
  },
  computed: {
    activeFragment() {
      return this.$route.hash || this.buttons[0].fragment;
    },
  },
  data() {
    return {
      buttons: [
        { title: "Client Properties", fragment: "#client-properties" },
        { title: "Device Uploads", fragment: "#device-uploads" },
        { title: "Device Twin", fragment: "#device-twin" },
      ],
    };
  },
};
</script>
